"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.state = void 0;
function state(s) {
    const { errorMessage, isAuthenticated, isProcessing } = s.session;
    return { errorMessage, isAuthenticated, isProcessing };
}
exports.state = state;
//# sourceMappingURL=selectors.js.map